module.exports = __webpack_public_path__ + "img/fr_start.2324f38a.png";